export class MissionTransformer {
  static transform(obj) {
    return {
      id: obj.id,
      contract_id: obj.attributes.contract_id,
      config: obj.attributes.config,
      name: obj.attributes.name,
      thirdPartyCode: obj.attributes.third_party_code,
      status: obj.attributes.status,
      questions: obj.attributes.questions,
      weightStart: obj.attributes.weight_start,
      weightEnd: obj.attributes.weight_end,
      weightEmpty: obj.attributes.weight_empty,
      startedAt: obj.attributes.started_at,
      finishedAt: obj.attributes.finished_at,
      createdAt: obj.attributes.created_at,
      updatedAt: obj.attributes.updated_at,
      createdBy: obj.attributes.created_by,
      lockedAt: obj.attributes.locked_at,
      lockedBy: obj.attributes.locked_by,
      archivedAt: obj.attributes.archived_at,
      inspectedBy: obj.attributes.inspected_by,
      data: obj.attributes.data,
      inspectedForFirmId: obj.attributes.inspected_for_firm_id,
    };
  }
}
